import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AUTHENTICATION_STATUS } from '../../services/authentication/authentication-utilities.service';
import { AuthenticationService } from '../../services/authentication/authentication.service';

export const errorGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);

  const error = route.queryParams['error'];
  const errorDescription = route.queryParams['error_description'];
  const stateParam = route.queryParams['state'];

  return authenticationService.authState$.pipe(
    map((authState) => {
      const isAuthenticated =
        authState.status === AUTHENTICATION_STATUS.AUTHENTICATED;
      if (error && errorDescription && stateParam && !isAuthenticated) {
        router.navigate(['/error'], {
          queryParams: {
            error,
            error_description: errorDescription,
            state: stateParam,
          },
        });
        return false;
      }
      return true;
    })
  );
};
